import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import axios from 'axios';
import { Form, Button, Container, Row, Col, Navbar } from 'react-bootstrap';
import FormInput from '../components/FormInput';
import { login, getUser  } from '../utils/auth';


function Login() {
  const { register, handleSubmit, formState: { errors } } = useForm();
  const [error, setError] = useState('');
  const navigate = useNavigate();
  // Base API URL from environment variable
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const onSubmit = async (data) => {
    try {
      const response = await axios.post(`${API_BASE_URL}/login.php`, data, {
        withCredentials: true
      });
      console.log('Login:', response.data);
      if (response.data.status === 'success') {
        console.log('login:', response.data.user);
        login(response.data.user);
        const { id, role, status } = response.data.user;
        // A pending/rejected employee (the only roles that can hold either
        // status — see register.php) gets routed to their own profile view
        // instead of the normal dashboard; UserViewDetails.js shows a
        // restricted read-only-or-editable view based on status there.
        if (role === 'employee' && status !== 'active') {
          navigate(`/admin/employee/view/${id}`);
        } else if (role === 'admin') {
          navigate('/admin/dashboard');
        } else if (role === 'masteradmin' || role === 'companyadmin' || role === 'departmentadmin') {
          navigate('/admin/dashboard');
        } else if (role === 'trainingadmin') {
          navigate('/vendor/dashboard');
        } else if (role === 'trainer') {
          navigate('/trainer/dashboard');
        } else if (role === 'employee') {
          navigate('/employee/dashboard');
        }
      } else {
        setError(response.data.message);
      }
    } catch (error) {
      setError('An error occurred. Please try again later.');
    }
  };

  useEffect(() => {
    const user = getUser();
    if (user) {
      if (user.role === 'employee' && user.status !== 'active') {
        navigate(`/admin/employee/view/${user.id}`);
        return;
      }
      switch (user.role) {
        case 'admin':
          navigate('/admin/dashboard');
          break;
        case 'masteradmin':
          navigate('/admin/dashboard');
          break;
        case 'companyadmin':
          navigate('/admin/dashboard');
          break;
        case 'departmentadmin':
          navigate('/admin/dashboard');
          break;
        case 'trainingadmin':
          navigate('/vendor/dashboard');
          break;
        case 'trainer':
            navigate('/trainer/dashboard');
            break;
        case 'employee':
          navigate('/employee/dashboard');
          break;
        default:
          navigate('/');
      }
    }
  }, [navigate]);


  return (
    <Container className="mt-5">
      <Row className="justify-content-md-center">
      
        <Col md={6}>
          <h2>Login</h2>
          {error && <div className="alert alert-danger">{error}</div>}
          <Form onSubmit={handleSubmit(onSubmit)}>
            <FormInput
              label="Email"
              type="email"
              name="email"
              register={register}
              validation={{ required: 'Email is required' }}
              error={errors.email}
            />
            <FormInput
              label="Password"
              type="password"
              name="password"
              register={register}
              validation={{ required: 'Password is required' }}
              error={errors.password}
            />
            <Button variant="primary" type="submit" className="mt-3 mr-1">Login</Button>
            <Link to="/register">
              <Button variant="primary" className="mt-3 mr-1">Register</Button>
            </Link>
            <div className="mt-2">
              <Link to="/forgot-password">Forgot Password?</Link>
            </div>

          </Form>
        </Col>
      </Row>
    </Container>
  );
}

export default Login;
